import useApiClient from './api-client'
import type { GetTopKeywordParams } from '@/types/search'

export const getTopKeyword = async (queryPayload: GetTopKeywordParams) => {
  const api = useApiClient<string[]>()
  const result = await api(`/search/keywords`, { query: queryPayload })

  return result
}
